import React from "react";
import PropTypes from "prop-types";
import { Margin, usePDF } from "react-to-pdf";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Mauhopdongvantaict from "components/Hopdongvantai/Mauphuluc/Mauhopdongvantaict.js";
const Mauhopdongvantai = React.memo(function Mauhopdongvantai(props) {
  const { hopdong_id } = props;
  const { toPDF, targetRef } = usePDF({
    filename: "Noidunghopdongvantai.pdf",
    page: { margin: Margin.MEDIUM },
  });
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "20%", marginLeft: 10, marginTop: 10 }}>
          <Button color="success" variant="contained" onClick={toPDF}>
            Tải file PDF
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: -15 }}>
        <div ref={targetRef} style={{ height: "auto" }}>
          <Mauhopdongvantaict hopdong_id={hopdong_id} />
        </div>
      </GridItem>
    </GridContainer>
  );
});

Mauhopdongvantai.propTypes = {
  hopdong_id: PropTypes.number,
};
export default Mauhopdongvantai;
